document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-type="add-to-cart-form"]').forEach((form) => {
    const productForm = form.closest('product-form');
    if (!productForm) return;

    productForm.addEventListener('variant:changed', (event) => {
      const variant = event.detail?.variant;
      const submitBtn = form.querySelector('[type="submit"][name="add"]');
      const hiddenId = form.querySelector('.product-variant-id');
      const quantityInput = form.querySelector('.quantity__input');
      const quantityWrapper = form.querySelector('quantity-input');

      if (!variant) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.querySelector('span')?.textContent && 
            (submitBtn.querySelector('span').textContent = window.variantStrings?.unavailable || 'Unavailable');
        }
        if (hiddenId) hiddenId.disabled = true;
        return;
      }

      // Update hidden variant id
      if (hiddenId) {
        hiddenId.value = variant.id;
        hiddenId.disabled = !variant.available;
      }

      // Update quantity input constraints from new variant rules
      if (quantityInput) {
        const min = variant.quantity_rule?.min || 1;
        const max = variant.quantity_rule?.max || null;
        const step = variant.quantity_rule?.increment || 1;

        quantityInput.min = min;
        quantityInput.dataset.min = min;
        quantityInput.step = step;
        if (max) {
          quantityInput.max = max;
        } else {
          quantityInput.removeAttribute('max');
        }
        // Reset value to min if current value is below new min
        if (parseInt(quantityInput.value) < min) {
          quantityInput.value = min;
        }
      }

      // Update submit button state
      if (submitBtn) {
        const soldOut = !variant.available;
        submitBtn.disabled = soldOut;

        const span = submitBtn.querySelector('span:not(.loading__spinner)');
        if (span) {
          if (soldOut) {
            span.textContent = window.variantStrings?.soldOut || 'Sold out';
          } else {
            span.textContent = window.variantStrings?.addToCart || 'Add to cart';
          }
        }
      }

      // Show/hide quantity selector based on availability
      if (quantityWrapper) {
        quantityWrapper.style.display = variant.available ? '' : 'none';
      }
    });
  });
});